import React from 'react'
import { LucideIcon } from 'lucide-react'

interface Tab {
  key: string
  label: string
  icon: LucideIcon
}

interface NavigationTabsProps {
  tabs: Tab[]
  activeTab: string
  onTabChange: (tabKey: string) => void
  className?: string
}

export const NavigationTabs: React.FC<NavigationTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = ''
}) => {
  // Keyboard accessibility handler
  const handleKeyDown = (e: React.KeyboardEvent, action: () => void) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      action()
    }
  }

  return (
    <div className={`bg-brand-dark-light/80 backdrop-blur-sm rounded-monumenta p-1 shadow-monumenta border border-gray-800/50 ${className}`}>
      <div className="flex flex-wrap gap-1">
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            onKeyDown={(e) => handleKeyDown(e, () => onTabChange(tab.key))}
            tabIndex={0}
            aria-label={tab.label}
            aria-current={activeTab === tab.key ? 'page' : undefined}
            className={`flex items-center gap-2 px-6 py-3 rounded-monumenta font-display font-semibold transition-all duration-300 flex-1 justify-center focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 focus:ring-offset-brand-dark ${
              activeTab === tab.key
                ? 'bg-brand-primary text-brand-dark shadow-monumenta-brand'
                : 'text-gray-300 hover:text-white hover:bg-brand-dark-lighter transform hover:scale-105'
            }`}
          >
            <tab.icon size={18} className="transition-transform duration-200" />
            <span className="hidden lg:inline">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
